import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromExpertise from '../../core/reducers/expertise.reducer';
import * as actionExpertise from '../../core/actions/expertise.actions';
import { Pagination } from '../../shared/models/pagination';
import { LazyLoadEvent } from 'primeng/api';
import { UserService } from '../../shared/services/user.service';
@Component({
  selector: 'app-expertise-list',
  templateUrl: './expertise-list.component.html',
  styleUrls: ['./expertise-list.component.scss']
})
export class ExpertiseListComponent implements OnInit {

  expertises = [
  ];
  pagination: Pagination;
  lastPagination: string = '';
  users: any[];

  states: any[]  =[
    {value:'' , label: 'Tous'},
    {value:'ExpertiseWorkflow/pending' , label: 'En cours'},
    {value:'ExpertiseWorkflow/invoiced' , label: 'Facturée'},
    {value:'ExpertiseWorkflow/archived' , label: 'Archivée'},
  ]


    public constructor(
      private store: Store<any>,
      private userService: UserService,
    ) {

    }
  ngOnInit() {
    this.store.select(fromExpertise.selectExpertises).subscribe(st => {this.expertises = st;});
    this.store.select(fromExpertise.selectExpertisePagination).subscribe(c => {console.log(c); this.pagination = c;});
    this.userService.getAll('name',2,{},0,20).subscribe(t => {
           this.users = [{value:{id:null}, label: 'Tous'}].concat((t.body).map(u => { return {label: u.publicIdentity, value:u}}));
    });    

  }
  addExpertise() {
    this.store.dispatch(new actionExpertise.AddExpertiseAction());
  }
  loadLazy(event: LazyLoadEvent) {        
    if (JSON.stringify(event) !== this.lastPagination ) {
      this.store.dispatch(new actionExpertise.LoadExpertisesAction(event.sortField,event.sortOrder, event.filters, event.first, event.rows));
      console.log('load lazy', event);
      this.lastPagination = JSON.stringify(event);    
    }
    
    
  }  

  openExperise(id) {
     this.store.dispatch(new actionExpertise.OpenTabAction(id)); 
  }
}
